import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";

// @General
export const somethingWentWrongToast = () =>
  toast.warning("Something Went Wrong", {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });

  export const notifyToast = () =>
  toast.success("successful", {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });

   export const overrideToast = () =>
  toast.success("successful", {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });

export const uploadInventoryToast = () =>
  toast.warning("Inventory List Is Empty", {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });

export const adminToast = () =>
  toast.success("Admin will be notify", {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });

export const addInventoryToast = () =>
  toast.warning("Please select an item and input price and quantity", {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });

// @Authentication
export const loginSuccessToast = () =>
  toast.success("Login Successful", {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
export const logoutSuccessToast = () =>
  toast.success("Logged out successfully", {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
export const invalidCredentialToast = () =>
  toast.warning("Invalid Credentials", {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
export const passwordChangedSuccessToast = () =>
  toast.success(
    `Password Updated Successfully.
    Sign in with your new password`,
    {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    }
  );

export const passwordChangedWarningToast = () =>
  toast.warn(`Invalid old password`, {
    position: "top-right",
    autoClose: 8000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });

// @Order
export const orderCreateSuccessToast = () =>
  toast.success("Order Created Successfully", {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });

// @faild order
export const failedOrder = () =>
  toast.warning("Order not successfully placed. Try again", {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });

// @dispatch success
export const dispatchAddedSuccessToast = () =>
  toast.success("Dispatch Created Successfully", {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });

// @dispatch exist
export const dipatchAlreadyExistToast = () =>
  toast.warning("Dispatch already exist", {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });

// @dispatch success
export const agentAddedSuccessToast = () =>
  toast.success("User Created Successfully", {
    position: "top-center",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });

// @dispatch exist
export const agentAlreadyExistToast = () =>
  toast.warning("User already exist in the system.", {
    position: "top-center",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });

// @update status
export const updateStatusToast = () =>
  toast.success("Status updated successfully", {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });

// @update status
export const recordUpdateToast = () =>
  toast.success("Record updated successfully", {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });

export const returnToast = () =>
  toast.success("Return request successful", {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });

export const sweetAlert = (test, url) => {
  Swal.fire({
    title: "Confirmed",
    text: test,
    icon: "success",
    confirmButtonText: "Okay",
  }).then(function () {
    window.location.href = `${url}`;
  });
};

export const successToast = (message) =>
  toast.success(message, {
    position: "top-center",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });

export const failToast = () =>
  toast.success("Bid has been passed to OPS successfully", {
    position: "top-center",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });

export const successAlert = () => {
  Swal.fire({
    // position: "top-end",
    icon: "success",
    title:
      "Admin has successfully sent a flag to vendor success for this request",
    showConfirmButton: false,
    timer: 7000,
  });
};

export const declineAlert = () => {
  Swal.fire({
    // position: "top-end",
    icon: "success",
    title: "Bid has been passed to OPS successfully",
    showConfirmButton: false,
    timer: 7000,
  });
};

export const pipeAlert = () => {
  Swal.fire({
    // position: "top-end",
    icon: "success",
    title: "Hospital added to lite successfully",
    showConfirmButton: false,
    timer: 7000,
  });
};
